export default "__VITE_ASSET__CBAUFbqF__"